import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Box, Button, InputLabel, TextField, Typography } from "@mui/material";
import toast from "react-hot-toast";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { editorConfig } from '../functions/utilities/EditorConfig'
import { ClassicEditor } from 'ckeditor5';
import 'ckeditor5/ckeditor5.css';
import '../styles/CKEditor.css'
import { delay } from '../functions/utilities/generic';
import { notifysubscribers } from '../functions/api/notifysubscribers';

const CreateBlog = () => {
    const id = localStorage.getItem("userId");
    const navigate = useNavigate();
    const [inputs, setInputs] = useState({
        title: "",
        description: "",
        content: "",
        image: "",
        EmailSubject: "",
        Emailcontent: "",
        category: "",
    });

    // input change
    const handleChange = (e) => {
        setInputs((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
        }));
    };

    //form
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const { data } = await axios.post("/api/v1/blog/create-blog", {
                title: inputs.title,
                description: inputs.description,
                content: inputs.content,
                image: inputs.image,
                user: id,
                category: inputs.category,
            });
            if (data?.success) {
                await delay(500);
                toast.success("Blog Created");
                notifysubscribers(inputs.EmailSubject, inputs.title, inputs.Emailcontent);
                await delay(500);
                navigate("/blogs");
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <form onSubmit={handleSubmit}>
                <Box
                    width={"50%"}
                    borderRadius={10}
                    padding={3}
                    margin="auto"
                    display="flex"
                    flexDirection={"column"}
                    marginTop="30px"
                >
                    <Typography
                        variant="h2"
                        textAlign={"center"}
                        fontWeight="bold"
                        padding={3}
                    >
                        Create A Blog Post
                    </Typography>
                    <InputLabel
                        sx={{ mb: 1, mt: 2, fontSize: "24px", fontWeight: "bold" }}
                    >
                        Title
                    </InputLabel>
                    <TextField
                        name="title"
                        value={inputs.title}
                        onChange={handleChange}
                        margin="normal"
                        variant="outlined"
                        required
                    />
                    <InputLabel
                        sx={{ mb: 1, mt: 2, fontSize: "24px", fontWeight: "bold" }}
                    >
                        Description
                    </InputLabel>
                    <TextField
                        name="description"
                        value={inputs.description}
                        onChange={handleChange}
                        margin="normal"
                        variant="outlined"
                        required
                    />
                    <InputLabel
                        sx={{ mb: 1, mt: 2, fontSize: "24px", fontWeight: "bold" }}
                    >
                        Content
                    </InputLabel>
                    <CKEditor
                        editor={ClassicEditor}
                        config={editorConfig}
                        data={inputs.content}
                        onReady={editor => {
                            // You can store the "editor" and use when it is needed.
                            console.log('Editor is ready to use!', editor);
                        }}
                        onChange={(event, editor) => {
                            const data = editor.getData();
                            setInputs((prevState) => {
                                return {
                                    ...prevState, content: data
                                }
                            });
                        }}
                        onBlur={(event, editor) => {
                            console.log('Blur.', editor);
                        }}
                        onFocus={(event, editor) => {
                            console.log('Focus.', editor);
                        }}
                        value={inputs.content}
                        required
                    />
                    <InputLabel
                        sx={{ mb: 1, mt: 2, fontSize: "24px", fontWeight: "bold" }}
                    >
                        Cover Image Link
                    </InputLabel>
                    <TextField
                        name="image"
                        value={inputs.image}
                        onChange={handleChange}
                        margin="normal"
                        variant="outlined"
                        required
                    />
                    <InputLabel
                        sx={{ mb: 1, mt: 2, fontSize: "24px", fontWeight: "bold" }}
                    >
                        Category
                    </InputLabel>
                    <TextField
                        select
                        name="category"
                        value={inputs.category}
                        onChange={handleChange}
                        SelectProps={{
                            native: true,
                        }}
                        variant="outlined"
                        required
                    >
                        <option value="">Select Category</option>
                        <option value="Nutrition">Nutrition</option>
                        <option value="Dogs">Dogs</option>
                        <option value="Cats">Cats</option>
                        <option value="Health & Wellness">Health & Wellness</option>
                        <option value="Training & Behavior">Training & Behavior</option>
                        <option value="Pet Adoption & Rescue">Pet Adoption & Rescue</option>
                    </TextField>

                    <InputLabel
                        sx={{ mb: 1, mt: 2, fontSize: "24px", fontWeight: "bold" }}
                    >
                        Email Subject
                    </InputLabel>
                    <TextField
                        name="EmailSubject"
                        value={inputs.EmailSubject}
                        onChange={handleChange}
                        margin="normal"
                        variant="outlined"
                        required
                    />
                    <InputLabel
                        sx={{ mb: 1, mt: 2, fontSize: "24px", fontWeight: "bold" }}
                    >
                        Email Description
                    </InputLabel>
                    <CKEditor
                        editor={ClassicEditor}
                        config={editorConfig}
                        data={inputs.Emailcontent}
                        onReady={editor => {
                            // You can store the "editor" and use when it is needed.
                            console.log('Editor is ready to use!', editor);
                        }}
                        onChange={(event, editor) => {
                            const data = editor.getData();
                            setInputs((prevState) => {
                                return {
                                    ...prevState, Emailcontent: data
                                }
                            });
                        }}
                        onBlur={(event, editor) => {
                            console.log('Blur.', editor);
                        }}
                        onFocus={(event, editor) => {
                            console.log('Focus.', editor);
                        }}
                        value={inputs.Emailcontent}
                        required
                    />
                    <Typography textAlign={"center"}>
                        <Button type="submit" color="primary" variant="contained" >
                            SUBMIT
                        </Button>
                    </Typography>
                </Box>
            </form>
        </>
    );
};
export default CreateBlog;